export enum ESyncLogsTabs {
    relatics = "relatics",
    asite = "asite",
    configuration = "configuration"
}


export enum EAsiteSyncMethods {
    View = "View",
    Manage = "Manage"
}